export default [
  { text: 'Name', value: 'name', width: '130px' },
  { text: 'CreatedAt', value: 'createdAt' },
  { text: 'UpdatedAt', value: 'updatedAt' },
  { text: 'Last Updated By', value: 'userName' },
  { text: '', value: 'actions' }
];
